import './index.css'
import React, { PureComponent } from "react"
import { getCourse } from "services/course"
import { getPresenter } from "services/presenter"
import { Tabs } from 'antd-mobile'
import CourseLayout from 'layouts/CourseLayout'
import { getThemeColor, getFileUrl } from 'utils/utils'
import IconFont from 'components/iconfont/IconFont'
import { isSafari } from 'utils/wechat/helper'

import IntroPanel from './components/IntroPanel'
import SectionPanel from './components/SectionPanel'
import KnowPanel from './components/KnowPanel'
import Player from './components/Player'
import Share from './components/Share'
import { AUDIO_PAUSED, AUDIO_LOADING, AUDIO_PLAYING } from './components/enum'

/**
 * 课程详情页
 */
export default class CourseRoute extends PureComponent {
    state = {
        // 记录当前播放状态，1：正在加载，2：正在播放，3：暂停
        playState: AUDIO_PAUSED,
        // 记录当前播放章节
        sectionId: -1,
        // 记录当前进度
        progress: '0%',
        // 当前文本
        course: undefined,
        // 当前课程主题主讲人集合
        presenters: [],
        // 是否可以完整播放
        canThrough: false,
        // 翻译按钮是否显示
        translateOn: false,
        // 当前翻译（true：英文、false：中文）
        translation: false,
    }

    get theme() {
        const { theme } = this.props.match.params
        return theme
    }

    get courseId() {
        const { id } = this.props.match.params
        return id
    }

    get themeColor() {
        return getThemeColor(this.theme).default
    }

    get translationColor() {
        return ['#D8D8D8', this.themeColor, this.themeColor, '#FFFFFF', this.themeColor]
    }

    get translationStyle() {
        const { translateOn } = this.state
        return { display: translateOn ? '' : 'none' }
    }

    handlePlay = () => {
        if (AUDIO_LOADING === this.state.playState) {
            this.sound.pause()
        } else if (AUDIO_PAUSED === this.state.playState) {
            this.sound.play()
        }
    }

    handleBackwards = () => {
        if (AUDIO_PLAYING !== this.state.playState) {
            const now = this.sound.currentTime;
            this.sound.currentTime = now - 10;
        }
    }

    handleTabChange = (_, tab) => {
        if (1 === tab) {
            this.setState({ translateOn: true })
        } else {
            this.setState({ translateOn: false })
        }
    }

    /**
     * @description IOS端offsetTop是距离html的距离，而Android端是距离上一级父组件的距离
     */
    handleSectionChange = (sectionId, duration) => {
        console.log('change-section===>', sectionId, duration)
        // 首先触发跳转
        document.getElementById(`sections`).scrollTop =
            document.getElementById(`section-${sectionId}`).offsetTop - (!isSafari() ? 15 : 60)
        if (AUDIO_PLAYING !== this.state.playState && this.state.sectionId !== sectionId) {
            this.setState({ sectionId })
            this.sound.currentTime = duration
        }
    }

    handleToggleTranslation = () => {
        this.setState(s => ({
            ...s,
            translation: !s.translation,
        }))
    }

    render() {
        const {
            ki,
            intros,
            knowledges,
            sections,
            points,
            illustration,
        } = this.state.course || {}

        const {
            playState,
            sectionId,
            progress,
            translation,
            presenters,
        } = this.state

        const tabStyles = getTabStyle(this.themeColor)

        const playerActions = {
            handlePlay: this.handlePlay,
            handleBackwards: this.handleBackwards,
            handleSectionChange: this.handleSectionChange,
        }

        const config =
            intros ?
                {
                    title: `${intros.episode} ${intros.title}`,
                    imgUrl: getFileUrl(this.theme, intros.cover),
                    desc: intros.synopsis[0]
                }
                :
                undefined


        return (
            <CourseLayout theme={this.theme}>
                {/* 分享配置 */}
                <Share config={config} />
                {
                    this.state.course && (
                        <Tabs
                            tabs={TABS}
                            initialPage={0}
                            destroyInactiveTab={false}
                            distanceToChangeTab={0.75}
                            useOnPan={false}
                            swipeable={false}
                            {...tabStyles}
                            onChange={this.handleTabChange}
                        >
                            <IntroPanel
                                theme={this.theme}
                                intros={intros}
                                presenters={presenters}
                            />
                            <SectionPanel
                                theme={this.theme}
                                sections={sections}
                                sectionId={sectionId}
                                presenters={presenters}
                                translation={translation}
                                illustration={illustration}
                                handleSectionChange={this.handleSectionChange}
                            />
                            <KnowPanel
                                theme={this.theme}
                                ki={ki}
                                knowledges={knowledges}
                            />
                        </Tabs>
                    )
                }
                {
                    this.state.course && (
                        <Player
                            theme={this.theme}
                            points={points}
                            playState={playState}
                            progress={progress}
                            sectionId={sectionId}
                            {...playerActions}
                        />
                    )
                }
                {/* 翻译按钮 */}
                {intros && intros.hasShowTranslateOn !== false && <span
                    className='course-translation'
                    onClick={this.handleToggleTranslation}
                    style={this.translationStyle}
                >
                    <IconFont
                        size={34}
                        color={this.translationColor}
                        name={translation ? 'translation-en' : 'translation-zh'}
                    />
                </span>}
            </CourseLayout>
        )
    }

    initAudio() {
        this.sound = new Audio()
        // 监听是否可以完整播放
        this.sound.oncanplaythrough = () => {
            console.log('sound-can-play-through')
            // 已播放，但是在加载
            if (AUDIO_PLAYING === this.state.playState) {
                this.setState({ playState: AUDIO_LOADING })
            }
            if (!this.state.canThrough) {
                this.setState({ canThrough: true })
            }
        }
        // 监听是否可播放
        this.sound.oncanplay = () => {
            console.log('sound-can-play')
        }
        // 监听错误
        this.sound.onerror = () => {
            console.log('sound-error')
        }
        // 监听播放
        this.sound.onplay = () => {
            console.log('sound-play')
            console.log(this.sound.currentTime);
            if (this.state.canThrough) {
                this.setState({ playState: AUDIO_LOADING })
            } else {
                this.setState({ playState: AUDIO_PLAYING })
            }
        }
        // 监听暂停
        this.sound.onpause = () => {
            console.log('sound-pause')
            this.setState({ playState: AUDIO_PAUSED })
        };
        // 监听时间的变化
        this.progressInterval = setInterval(() => {
            this.setState({ progress: `${this.sound.currentTime * 100 / this.sound.duration}%` })
            // 检查小节是否变化
            const { stamps } = this.state.course
            const current = this.sound.currentTime
            for (let i = 0; i < stamps.length; i++) {
                if (current > stamps[i].duration &&
                    current < (i + 1 < stamps.length ? stamps[i + 1].duration : this.sound.duration)) {
                    if (this.state.sectionId !== stamps[i])
                        this.setState({ sectionId: stamps[i].id })
                    return
                }
            }
        }, 1500)
        this.sound.src = getFileUrl(this.theme, `/sound/course${this.courseId}.mp3`)
        this.sound.loop = true
        // if (this.isAndroidOrIOS()) 
        //     this.sound.play();
        // this.sound.play();
    }

    async initPage() {
        const presenters = await getPresenter(this.theme)
        // 获取数据
        const course = await getCourse({
            theme: this.theme,
            id: this.courseId,
        });
        // console.log('course数据', course);

        // 数据处理，目的是简化json文件的数据结构以及音频的节点写多次的问题
        let { stamps, points, sections } = course || {};
        if (stamps) {
            stamps.forEach((s, i) => {
                let { id, duration } = s;
                checkIdAndSetDuration({ arr: points, idValue: id, durationValue: duration });
                checkIdAndSetDuration({ arr: sections, idValue: id, durationValue: duration });
            })
        }
        function checkIdAndSetDuration(opt) {
            if (!opt) {
                return false;
            }
            let { arr, idValue, durationValue } = opt;
            arr.forEach((a, i) => {
                if (a.id === idValue) {
                    a.duration = durationValue;
                }
            })
        }
        // 数据处理，目的是简化json文件的数据结构以及音频的节点写多次的问题

        if (course && presenters) {
            const { intros } = course
            const documentTitle = `${intros.episode} ${intros.title}`
            // 文档标题标题
            document.title = documentTitle
            // 设置内容展示
            this.setState({
                course,
                presenters: presenters.members,
            })
            // 配置音频
            this.initAudio()
        }
    }

    componentDidMount() {
        this.initPage()
    }

    componentWillUnmount() {
        if (this.progressInterval)
            clearInterval(this.progressInterval)
        if (this.sound)
            this.sound.src = null
    }
}

const TABS = [
    { title: '简介', sub: '1' },
    { title: '音频字幕', sub: '2' },
    { title: '知识点', sub: '3' },
]

const getTabStyle = themeColor => ({
    tabBarBackgroundColor: themeColor,
    tabBarActiveTextColor: '#ffffff',
    tabBarInactiveTextColor: 'rgba(255,255,255,0.7)',
    tabBarUnderlineStyle: {
        border: `1px solid #ffffff`
    },
    tabBarTextStyle: {
        fontWeight: 'bold'
    }
})
